import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import Quill from 'quill';

@Component({
  selector: 'app-quill-editor',
  templateUrl: './quill-editor.component.html',
  styleUrls: ['./quill-editor.component.scss']
})
export class QuillEditorComponent implements OnInit {
  @Input() control!: FormControl; // Receive FormControl from parent
  @Output() submit = new EventEmitter<string>();


  @ViewChild('editorContainer', { static: false }) editorContainer!: ElementRef;
  quillEditor: any;
  toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    ['blockquote', 'code-block'],
    ['link', 'image', 'video', 'formula'],
  
    [{ 'header': 1 }, { 'header': 2 }],               // custom button values
    [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'list': 'check' }],
    [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
    [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
    [{ 'direction': 'rtl' }],                         // text direction
  
    [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
  
    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
    [{ 'font': [] }],
    [{ 'align': [] }],
  
    ['clean']                                         // remove formatting button
  ];
  ngOnInit(): void {
    if (this.control) {
      this.control.valueChanges.subscribe(value => {
        if (this.quillEditor && value !== this.quillEditor.root.innerHTML) {
          this.quillEditor.root.innerHTML = value; // Update editor when FormControl value changes
        }
      });
    }
  }

  ngAfterViewInit(): void {
    this.initializeQuillEditor();
    if (this.control?.value) {
      this.quillEditor.root.innerHTML = this.control.value; // Initialize with form value
    }
  }

  initializeQuillEditor(): void {
    this.quillEditor = new Quill(this.editorContainer.nativeElement, {
      theme: 'snow',
      modules: {
        toolbar: this.toolbarOptions
      }
    });

    this.quillEditor.on('text-change', () => {
      const content = this.quillEditor.root.innerHTML;
      this.control.setValue(content, { emitEvent: false });
    });

    this.editorContainer.nativeElement.addEventListener('paste', (e: ClipboardEvent) => {
      const items = e.clipboardData?.items;
      if (!items) return;
      for (const item of Array.from(items)) {
        if (item.type.startsWith('image/')) {
          e.preventDefault();
          const file = item.getAsFile();
          if (!file) return;
          const reader = new FileReader();
          reader.onload = (event) => {
            const base64 = event.target?.result as string;
            const range = this.quillEditor.getSelection(true);
            this.quillEditor.insertEmbed(range.index, 'image', base64, 'user');
            this.quillEditor.setSelection(range.index + 1, 0, 'silent');
          };
          reader.readAsDataURL(file);
          return;
        }
      }
    });
  }

  onSubmit(): void {
    this.submit.emit(this.control.value);
  }
}
